export enum StatusEnum {
    ACTIVE = "active",
    DELETED = "deleted",
    DISABLED = "disabled"
}
